import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <span>
        Created with love by&nbsp;
        <a
          href="https://www.linkedin.com/in/mahmoud-ayed-111329207"
          target="_blank"
          rel="noopener noreferrer"
          className="name-footer"
        >
          &#9825; Mahmoud &#9825;&nbsp;
        </a>
        | <span className="copyright">&#169;</span>
        <span id="currentYear">{new Date().getFullYear()}</span> All rights
        reserved.
      </span>
    </div>
  );
};

export default Footer;
